import { TextInput } from 'react-hook-form-mantine';
import styled from 'styled-components';
import { PersonSearchForm } from './CapManageSidebar.types';

export const TextInputWithoutTopMargin = styled(TextInput<PersonSearchForm>)`
	flex: 1;
	input {
		margin-top: 0;
	}
`;
